import { render, staticRenderFns } from "./NavigateButton.vue?vue&type=template&id=2763b1a8&scoped=true&"
import script from "./NavigateButton.vue?vue&type=script&lang=js&"
export * from "./NavigateButton.vue?vue&type=script&lang=js&"
import style0 from "./NavigateButton.vue?vue&type=style&index=0&id=2763b1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763b1a8",
  null
  
)

export default component.exports